import React from "react";
import { GitGraph, LayoutPanelLeft } from "lucide-react";
import { HamburgerMenu, TopMenu } from "./navigationexports";
import { useNavigationVisibility } from "../context/NavigationContext";
import { useSafeLocation } from "../hooks/useSafeRouter";
import { SafeLink } from "../ui/SafeLink";
// phase 2 Enquiry items
import { FaEnvelope } from "react-icons/fa";
import { useAccumulate } from "../context/AccumulateContext";
// end of phase 2 Enquiry items


interface IHeaderProps {
    user: any;
    isCustomerPortal: boolean;
    isMobileScreen: boolean;
}



export const Header: React.FC<IHeaderProps> = ({
    user,
    isCustomerPortal,
    isMobileScreen
}) => {
    const { isNavVisible } = useNavigationVisibility();
    const location = useSafeLocation();
    const isHomePage = location.pathname === '/';   



    // phase 2 enquiry items
    const { quoteItems } = useAccumulate();
    //  end of phase 2 enquiry items

    // Hide navigation on homepage until interaction, always show on other pages
    const shouldShowNav = !isHomePage || isNavVisible;

    // phase 2 Quote - get quote count from local storage or context
    // const [quoteCount, setQuoteCount] = React.useState(0);
    // end of phase 2 Quote

    return (
        <nav className={`
      dark fixed top-0 left-0 z-50 flex lg:justify-between lg:items-center w-full min-h-[4rem] items-center px-4 
      bg-black text-gray-100 border-b-4 border-b-harvey-foreground shadow-md bg-[50%]
      transition-all duration-500 ease-in-out
      ${shouldShowNav
                ? 'translate-y-0 opacity-100'
                : '-translate-y-full opacity-0'
            }
    `}>
            {/* Logo */}
            <SafeLink to="/">
                <div className="h-8 lg:w-1/10 flex items-center">
                    <img
                        className="h-full w-full"
                        alt="Harvey Norman Logo"
                        src="https://hncnzwww.blob.core.windows.net/www/img/hnc-white-logo-website.svg"
                    />
                </div>
            </SafeLink>

            {/* Navigation Menu */}
            {isMobileScreen ? (
                <div className="ml-auto mr-14 cursor-pointer z-50">
                    <HamburgerMenu />
                </div>
            ) : (
                <div className="lg:w-8/10">
                    <TopMenu className="bg-black text-gray-100" />
                </div>
            )}

            {/* Portal Link - Only for logged in users outside customer portal */}
            {user?.result.id && !isCustomerPortal && (
                <div className="mr-14 cursor-pointer z-50 lg:w-1/10">
                    <SafeLink
                        to="customer-portal"
                        className="flex flex-row items-center space-x-1 cursor-pointer group"
                    >
                        <LayoutPanelLeft
                            className="h-4 w-4 group-hover:text-white transition-colors duration-200 text-xs lg:text-xs xl:text-xs 2xl:text-sm"
                            strokeWidth={1}
                            color="white"
                        />
                        <p className="uppercase text-xs lg:text-xs xl:text-xs 2xl:text-sm bg-transparent hover:bg-transparent focus:bg-transparent data-[state=open]:bg-transparent data-[active]:bg-transparent">
                            Portal
                        </p>
                    </SafeLink>
                </div>
            )}

            

           

            {/*============= PHASE 2 Enquiry Items =================== */}
            {/* <a
                href={`mailto:sam.sek@nz.harveynorman.com?subject=Quote Request&body=${encodeURIComponent(
                    `I'd like to enquire about the following items:\n\n` +
                    quoteItems.map(item => `- ${item.name} (Qty: ${item.quantity})`).join("\n")
                )}`}
                className="mr-14 cursor-pointer z-50 lg:w-1/10 flex items-center"
            >
                <div className="relative">
                    <FaEnvelope className="text-lg md:text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl text-white" />
                    {quoteItems.length > 0 && (
                        <span className="absolute -top-2 -right-2 bg-harvey-red text-white text-xs font-bold rounded-full px-2 py-0.5">
                            {quoteItems.length}
                        </span>
                    )}
                </div>
            </a> */}

            {/* <SafeLink to="/quote" className="mr-14 cursor-pointer z-50 lg:w-1/10 flex items-center">
                <div className="relative">
                    <FaEnvelope className="text-lg md:text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl text-white" />
                    {quoteItems.length > 0 && (
                        <span className="absolute -top-2 -right-2 bg-harvey-red text-white text-xs font-bold rounded-full px-2 py-0.5">
                            {quoteItems.length}
                        </span>
                    )}
                </div>
            </SafeLink> */}
            {/* ============== end of phase 2 Enquiry Items =================== */}

        </nav>
    );
};
